import { StateCreator } from 'zustand'
import { Store } from '../type'

type EmailSlice = Pick<Store, 'setEmail' | 'email'>
export const emailSlice: StateCreator<Store, [], [], EmailSlice> = (set) => ({
  email: '',
  setEmail: (email: string) => {
    set({ email })
  },
})
